import React from "react";
import { InlineEditor } from "@hid-galaxy-ui/galaxy-react";
import {
  DESCRIPTION_MAX_LENGTH,
  descriptionEditorToolBarConfig,
  stripHtml,
} from "./descriptionEditorConfig";

type Props = {
  id: string;
  label?: string;
  placeholder: string;
  value: string;
  maxLength?: number;
  onChange: (value: string) => void;
};

const DescriptionEditorField: React.FC<Props> = ({
  id,
  label = "Description",
  placeholder,
  value,
  maxLength = DESCRIPTION_MAX_LENGTH,
  onChange,
}) => {
  const textLength = stripHtml(value).length;

  return (
    <div className="form-field tm-description-editor-field">
      <div className="field-label-row">
        <label htmlFor={id}>{label}</label>
        <span className="char-count">
          {textLength}/{maxLength}
        </span>
      </div>
      <InlineEditor
        id={id}
        placeholder={placeholder}
        toolBarConfig={descriptionEditorToolBarConfig}
        editorData={value}
        handleOnChange={(nextValue: string) => {
          if (stripHtml(nextValue).length > maxLength) return;
          onChange(nextValue);
        }}
      />
    </div>
  );
};

export default DescriptionEditorField;
